import React from 'react';
import ReactDOM from 'react-dom/client';
import './hazcheck-theme.css';
import './index.css';
import App from './App';
import { armAppReadyFallback, startEmbedBridge } from './services/embed/embedBridge';
import { authService } from '@/services/auth/authService';
import { queryClient } from '@/api/queryClient';
import { profileQueryOptions } from '@/services/user/hooks';
import { useAuthStore } from '@/stores/authStore';
import { initFaro } from '@/config/faro';

const initializeTheme = () => {
  let savedTheme = 'light';
  try {
    savedTheme = localStorage.getItem('theme') || 'light';
  } catch {
    /* empty */
  }
  document.documentElement.className = `${savedTheme}-mode`;
};

// Signal index.html to dismiss the boot splash once the first view has painted.
const signalAppReady = () => {
  requestAnimationFrame(() => {
    window.__hcAppReady = true;
    window.dispatchEvent(new CustomEvent('hc-app-ready'));
  });
};

const start = () => {
  initFaro();
  initializeTheme();
  startEmbedBridge();

  const rootElement = document.getElementById('root');
  if (!rootElement) {
    console.error('Root element not found');
    return;
  }
  const root = ReactDOM.createRoot(rootElement);

  // The boot splash in index.html stays up through keycloak.init() (#root is empty
  // until then), so route loaders never fire without a token. .finally so a thrown
  // init still mounts <App> (the store carries the error); the trailing .catch
  // keeps a rejecting initialize from firing an unhandled rejection.
  authService
    .initialize()
    .finally(() => {
      if (useAuthStore.getState().isAuthenticated) {
        queryClient.prefetchQuery(profileQueryOptions);
      }
      root.render(
        <React.StrictMode>
          <App />
        </React.StrictMode>
      );
      signalAppReady();
      armAppReadyFallback();
    })
    .catch(console.error);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', start);
} else {
  start();
}
